const SectionNav = ({ items, label = 'En esta página' }) => (
  <nav aria-label={label} className="sticky top-20 z-30 border-b border-leaf/10 bg-ivory/90 backdrop-blur-md">
    <div className="mx-auto flex max-w-7xl gap-2 overflow-x-auto px-4 py-3 sm:px-6 lg:px-8">
      {items.map((item) => (
        <a
          key={item.href}
          href={item.href}
          className="shrink-0 rounded-full px-4 py-2 text-sm font-medium text-mist transition-colors hover:bg-cream hover:text-leaf"
        >
          {item.label}
        </a>
      ))}
    </div>
  </nav>
)

export default SectionNav
